import { API_URL } from '../../../app-config/constants';
import type NotificationLogDto from '../../../types/NotificationLogDto';
import { get, post } from '../request';

const BASE = `${API_URL}/notificationLogs`;

getLatest.operation = 'READ';
export function getLatest(params: { offset?: number; limit?: number } = {}) {
    return get<NotificationLogDto[]>(`${BASE}/latest`, {
        getData: {
            offset: params.offset?.toString(),
            limit: params.limit?.toString(),
        },
    });
}

markAsRead.operation = 'COMMAND';
export function markAsRead(id: string) {
    return post<NotificationLogDto>(`${BASE}/markAsRead/${id}`);
}

markAsUnread.operation = 'COMMAND';
export function markAsUnread(id: string) {
    return post<NotificationLogDto>(`${BASE}/markAsUnread/${id}`);
}

markAllAsRead.operation = 'READ'; // this is a hack...
export function markAllAsRead() {
    return post(`${BASE}/markAllAsRead`);
}

export function markAllAsReadWithoutCache() {
    return post(`${BASE}/markAllAsRead`);
}
